'use client';

import { format } from 'date-fns';

// @mui
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';

// locales
import { useTranslate } from 'src/locales';
// hooks
// types
import { useRouter } from 'next/navigation';

// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';

import { useBoolean } from '../../../../../hooks/use-boolean';
import { ConfirmDialog } from '../../../../../components/custom-dialog';
//
// import CustomerQuickEditForm from './customer-quick-edit-form';

// ----------------------------------------------------------------------

type Props = {
  selected: boolean;
  onEditRow: VoidFunction;
  row: any;
  onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  page?: string;
};

export default function ProfileHistoryTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  page,
}: Props) {
  const { t } = useTranslate();

  const { id, invoiceNumber, merchant, activity, due, revenue, amount, myPercent, status, name } =
    row;

  const confirm = useBoolean();

  const quickEdit = useBoolean();

  const popover = usePopover();

  const router = useRouter();

  const openDetails = useBoolean();

  const handleDetails = () => {
    // router.push(paths.dashboard.accounting.invoices.details(id));
  };

  return (
    <>
      <TableRow hover selected={selected} sx={{ cursor: 'pointer' }}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }} onClick={openDetails.onTrue}>
          {invoiceNumber}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }}>
          {page === 'invoices' ? (
            <ListItemText
              primary={name}
              secondary={`INV-${merchant}`}
              primaryTypographyProps={{ typography: 'body2' }}
              secondaryTypographyProps={{
                fontSize: 12,
                component: 'p',
                color: 'text.disabled',
              }}
              onClick={handleDetails}
            />
          ) : (
            <>{merchant}</>
          )}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }} onClick={openDetails.onTrue}>
          {activity}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }}>
          <ListItemText
            primary={format(new Date(due), 'dd.MM.yyyy')}
            secondary={format(new Date(due), 'HH:mm a')}
            primaryTypographyProps={{ typography: 'body2' }}
            secondaryTypographyProps={{
              fontSize: 12,
              component: 'p',
              color: 'text.disabled',
            }}
          />
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }} onClick={openDetails.onTrue}>
          ₪{revenue}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }} onClick={openDetails.onTrue}>
          ₪{amount}
        </TableCell>

        <TableCell>{myPercent}</TableCell>

        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          {t('Delete')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            onEditRow();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" />
          {t('Edit')}
        </MenuItem>
      </CustomPopover>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title={t('Delete')}
        content={t('Are you sure want to delete?')}
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            {t('Delete')}
          </Button>
        }
      />
    </>
  );
}
